angular.module('tradersyard').directive('friendForm', [
    '$parse',
    'graph-friend-factory',
    '$timeout',
    function ($parse, $client, $timeout) {
        return {
            scope: true,
            link: function ($scope, $element, $attr) {
                var client;

                $timeout(function () {
                    client = $client.entry($parse($attr.entry)($scope), $parse($attr.entryId)($scope));
                });

                $scope.unfriend = function (node) {
                    client.unfriend(node.id).then(function (response) {
                        if (response.data.state === 0) {
                            node.im_friend = false;

                            if ($attr.after) {
                                var phase = $scope.$parent.$$phase;
                                if (phase == '$apply' || phase == '$digest') $scope.$parent.$eval($attr.after);
                                else $scope.$parent.$apply($attr.after);
                            }
                        }
                    });
                };
            },
        };
    },
]);
